import { TypedNode } from "../_Base";
import { CoreGroup } from "../../../core/geometry/Group";
import { ObjectType } from "../../../core/geometry/Constant";
import { NodeContext } from "../../poly/NodeContext";
import { FlagsControllerDBO } from "../utils/FlagsController";
import { BaseSopOperation } from "../../operations/sop/_Base";
var MESSAGE = /* @__PURE__ */ ((MESSAGE2) => {
  MESSAGE2["FROM_SET_CORE_GROUP"] = "from set_core_group";
  MESSAGE2["FROM_SET_GROUP"] = "from set_group";
  MESSAGE2["FROM_SET_OBJECTS"] = "from set_objects";
  MESSAGE2["FROM_SET_OBJECT"] = "from set_object";
  MESSAGE2["FROM_SET_GEOMETRIES"] = "from set_geometries";
  MESSAGE2["FROM_SET_GEOMETRY"] = "from set_geometry";
  return MESSAGE2;
})(MESSAGE || {});
const INPUT_GEOMETRY_NAME = "input geometry";
const DEFAULT_INPUT_NAMES = [INPUT_GEOMETRY_NAME, INPUT_GEOMETRY_NAME, INPUT_GEOMETRY_NAME, INPUT_GEOMETRY_NAME];
export class TypedSopNode extends TypedNode {
  constructor() {
    super(...arguments);
    this.flags = new FlagsControllerDBO(this);
  }
  static context() {
    return NodeContext.SOP;
  }
  static displayedInputNames() {
    return DEFAULT_INPUT_NAMES;
  }
  initializeBaseNode() {
    this.flags.display.set(false);
    this.flags.display.onUpdate(() => {
      if (this.flags.display.active()) {
        const parent = this.parent();
        if (parent && parent.displayNodeController) {
          parent.displayNodeController.setDisplayNode(this);
        }
      }
    });
    this.io.outputs.setHasOneOutput();
  }
  setCoreGroup(core_group) {
    this._setContainer(core_group, "from set_core_group" /* FROM_SET_CORE_GROUP */);
  }
  setObject(object) {
    this._setContainerObjects([object], "from set_object" /* FROM_SET_OBJECT */);
  }
  setObjects(objects) {
    this._setContainerObjects(objects, "from set_objects" /* FROM_SET_OBJECTS */);
  }
  setGeometry(geometry, type = ObjectType.MESH) {
    const object = this.createObject(geometry, type);
    this._setContainerObjects([object], "from set_geometry" /* FROM_SET_GEOMETRY */);
  }
  setGeometries(geometries, type = ObjectType.MESH) {
    const objects = [];
    let object;
    for (let geometry of geometries) {
      object = this.createObject(geometry, type);
      objects.push(object);
    }
    this._setContainerObjects(objects, "from set_geometries" /* FROM_SET_GEOMETRIES */);
  }
  _setContainerObjects(objects, message) {
    const core_group = this.containerController.container().coreContent() || new CoreGroup();
    core_group.setObjects(objects);
    core_group.touch();
    this._setContainer(core_group);
  }
  static createObject(geometry, type, material) {
    return BaseSopOperation.createObject(geometry, type, material);
  }
  createObject(geometry, type, material) {
    return TypedSopNode.createObject(geometry, type, material);
  }
  static createIndexIfNone(geometry) {
    BaseSopOperation.createIndexIfNone(geometry);
  }
  _createIndexIfNone(geometry) {
    TypedSopNode.createIndexIfNone(geometry);
  }
}
export class BaseSopNodeClass extends TypedSopNode {
}
